export default function SciPy_Graphs() {
  return (
    <div>
      <h1>SciPy Graphs</h1>
    </div>
  );
}
